import { useRef } from 'react';
import styled from 'styled-components';
import { motion, useInView } from 'framer-motion';

const clients = [
  { label: 'Industria Alimentaria',    icon: '🌽' },
  { label: 'Logística y Distribución', icon: '🚛' },
  { label: 'Manufactura',              icon: '🏭' },
  { label: 'Almacenamiento',           icon: '📦' },
  { label: 'Exportación',              icon: '🌎' },
  { label: 'Sector Farmacéutico',      icon: '💊' },
  { label: 'Comercio',                 icon: '🏪' },
  { label: 'Agroindustria',            icon: '🌿' },
];

export default function Clients() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <Section id="clients">
      <Inner>
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
        >
          <SectionTag>Sectores Atendidos</SectionTag>
          <SectionTitle>¡Agradecemos <AccentWord>su confianza!</AccentWord></SectionTitle>
          <Sub>Tú también puedes contar con nosotros para ser tu proveedor de tarimas.</Sub>
        </motion.div>

        <TagsWrap>
          {clients.map((c, i) => (
            <motion.div
              key={c.label}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.45, delay: 0.1 + i * 0.07 }}
            >
              <ClientTag>
                <TagNum>0{i + 1}</TagNum>
                <TagEmoji>{c.icon}</TagEmoji>
                <TagLabel>{c.label}</TagLabel>
              </ClientTag>
            </motion.div>
          ))}
        </TagsWrap>
      </Inner>
    </Section>
  );
}

const Section = styled.section`
  background: transparent;
  padding: 6rem 2rem;
`;

const Inner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

const SectionTag = styled.p`
  font-size: 0.72rem;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--blue);
  border-left: 3px solid var(--red);
  padding-left: 0.75rem;
  margin-bottom: 1rem;
`;

const SectionTitle = styled.h2`
  font-size: clamp(1.8rem, 4vw, 3rem);
  margin-bottom: 1rem;
  color: var(--blue);
`;

const AccentWord = styled.span`
  color: var(--red);
  text-shadow: var(--shadow-3d);
`;

const Sub = styled.p`
  font-size: 0.95rem;
  color: var(--text-sub);
  margin-bottom: 3.5rem;
`;

const TagsWrap = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border-top: 2px solid var(--blue);
  border-left: 1px solid var(--border);

  @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 480px) { grid-template-columns: 1fr; }
`;

const ClientTag = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding: 2rem 1.75rem;
  border-right: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  cursor: default;
  transition: background 0.2s;

  @media (hover: hover) {
    &:hover {
      background: var(--blue-lt);
    }
    &:hover span:last-child {
      color: var(--blue);
    }
  }
`;

const TagNum = styled.span`
  font-family: 'Bebas Neue', sans-serif;
  font-size: 0.9rem;
  letter-spacing: 0.12em;
  color: var(--red);
`;

const TagEmoji = styled.span`
  font-size: 1.8rem;
  line-height: 1;
`;

const TagLabel = styled.span`
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text);
  transition: color 0.2s;
`;
